import { ModelEvent } from 'ng2-app/modules/shared/stores/events/model.event';

export class InjectEvent<M> extends ModelEvent<M> {
    constructor(instance: M) {
        super('inject', instance);
    }
}
